
import {Component, Vue} from "vue-property-decorator";
import VueSection from "../components/section/index.vue";
import VueMore from "../components/btn.vue";
import VueZz from "../components/zzzs.vue";

@Component({
    components: {
        VueSection,
        VueMore,
        VueZz
    }
})
export default class HomeClass extends Vue {
    public rowMergeArrs: any = {} // 包含需要一个或多个合并项信息的对象

    private swiper: any = null;
    private activeIndex: number = 0;
    private lastActiveIndex: number = 0;
    public show:any=false;

    public getProportion(): number {
        let windowWidth: number = document.documentElement.clientWidth || document.body.clientWidth;
        return windowWidth / 1920;
    }
    private mounted(): void{
        if (this.$refs.slideCarousel) this.slideBanner();
        setTimeout(()=>{
            let _anime = (window as any).anime;
            _anime({
                targets: '.img-title1',
                translateX: 1160 * this.getProportion(),
                opacity: ['0', '1'],
                delay: 500,
                easing: 'easeOutExpo',
                duration: 600
            });
            _anime({
                targets: '.img-title2',
                translateX: 1300 * this.getProportion(),
                opacity: ['0', '1'],
                delay: 800,
                easing: 'easeOutExpo',
                duration: 600
            });

            _anime({
                targets: '.img-title3',
                translateX: 1450 * this.getProportion(),
                opacity: ['0', '1'],
                delay: 1100,
                easing: 'easeOutExpo',
                duration: 600
            });
        },100)
    }

    public touchstart(){
        console.log(99888)
    }

    public rollScroll(){
        console.log("轮播")
    }

    slideBanner() {
        let that = this;
        //选中的轮播图
        let box = document.querySelector('.el-carousel__container');
        let startPoint = 0;
        let stopPoint = 0;
        //重置坐标
        let resetPoint = function() {
            startPoint = 0;
            stopPoint = 0;
        }
        box.addEventListener("mousedown", function(e:any){
            console.log(e);
            startPoint = e.pageX;
            box.addEventListener("mousemove", function(e:any){
                stopPoint = e.pageX;
            })
        })


        box.addEventListener("mouseup", function(){
            if (stopPoint === 0 || startPoint - stopPoint === 0) {
                resetPoint();
                return;
            }
            if (startPoint - stopPoint > 0) {
                resetPoint();
                that.$refs.slideCarousel.next();
                return;
            }
            if (startPoint - stopPoint < 0) {
                resetPoint();
                that.$refs.slideCarousel.prev();
                return;
            }
        })


        //手指按下
        box.addEventListener("touchstart", function(e:any) {
            //手指点击位置的X坐标
            startPoint = e.changedTouches[0].pageX;
        });
        //手指滑动
        box.addEventListener("touchmove", function(e:any) {
            //手指滑动后终点位置X的坐标
            stopPoint = e.changedTouches[0].pageX;
        });
        //当手指抬起的时候，判断图片滚动离左右的距离

        box.addEventListener("touchend", function() {
            if (stopPoint === 0 || startPoint - stopPoint === 0) {
                resetPoint();
                return;
            }
            if (startPoint - stopPoint > 0) {
                resetPoint();
                that.$refs.slideCarousel.next();
                return;
            }
            if (startPoint - stopPoint < 0) {
                resetPoint();
                that.$refs.slideCarousel.prev();
                return;
            }
        });
    }

    public onActiveIndex: number = 0;

    public mouseenter(index: number) {
        console.log(11)

        this.onActiveIndex = index;
    }

    public mouseleave() {
        console.log(22)
    }

    public tabClick(index:any){
        this.$router.push(`/product?type=${index}`)
    }

    public handleSelect(key: any) {
        this.$router.push(`/solution?type=${key}`)
    }
}
